export function formatNbaDetailNumber(value, { suffix = "" } = {}) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return `${number.toLocaleString("en-US", { maximumFractionDigits: 2 })}${suffix}`;
}

export function formatNbaResearchDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return String(value);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
}

export function nbaRestB2bLabel(row) {
  const status = String(row?.["Rest Evidence Status"] ?? "").trim().toUpperCase();
  if (status !== "AVAILABLE") return "UNKNOWN / N/A";
  if (row?.b2b_today === true) return "B2B";
  if (row?.b2b_today === false) return "NOT B2B";
  return "UNKNOWN / N/A";
}

const normalizeOpponent = (value) => String(value ?? "").toUpperCase()
  .replace(/^(@|VS\.?)\s+/, "").replace(/[^A-Z0-9]/g, "");

export function nbaH2hRows(row, getRows, max = 10) {
  const opponent = normalizeOpponent(row?.Opponent ?? row?.["Opponent Name"]);
  if (!opponent) return [];
  return getRows(row, { vsOpp: true, max, range: "H2H" }).filter((game) => (
    normalizeOpponent(game?.Opponent ?? game?.["Opponent Name"] ?? game?.Opp ?? game?.OppTeam) === opponent
  ));
}
